import { defaults } from 'lodash';
import React, { createContext, useContext, useMemo, } from 'react';
const foundationContext = createContext(undefined);
export const FoundationContextProvider = ({ size, children }) => {
    const contextValue = useMemo(() => ({
        size,
    }), [size]);
    return (React.createElement(foundationContext.Provider, { value: contextValue }, children));
};
export const useFoundationContext = () => useContext(foundationContext);
/* eslint-disable max-len,@typescript-eslint/comma-dangle */
/**
 * Mainly for docs purposes - sometimes we need to show how components work without contextual defaults
 */
export const FoundationContextReset = (props) => (React.createElement(foundationContext.Provider, { value: undefined, ...props }));
/**
 * Allows to integrate the component with foundation context by creating component props default values from context using provided mapping.
 * @returns hook that accepts directly passed component props and provides final component props and props that should be given to inner context.
 * @param contextToProps maps current context into default component properties.
 * @param propsToInnerContext maps final component props into context that can be provided for component children.
 * @param defaultProps component default props when context is not provided
 **/
export const createUseFoundationHook = (contextToProps, propsToInnerContext, defaultProps) => ({
    useFoundation: (props) => {
        const foundationContext = useFoundationContext();
        const componentProps = defaults({}, props, foundationContext ? contextToProps(foundationContext) : defaultProps);
        const innerContextProps = propsToInnerContext(componentProps);
        return { componentProps, innerContextProps };
    },
});
//# sourceMappingURL=foundationContext.js.map